import { tm } from '@captaincause/ui/tm'
import type { LayoutProps } from './App'

export function BaseLayout({ children, className = '' }: LayoutProps) {
  return (
    <div id="layout" className={tm('grid grid-cols-1 grid-rows-1', className)}>
      {children}
    </div>
  )
}
